import thunk from 'redux-thunk';
import serverVars from 'server-vars';
import { initializePrerenderedCheckout } from 'dibs-checkout/exports/prerender/initializePrerenderedCheckout.ts';
import { getItemIdFromUri } from '../../utils/getItemIdFromUri.ts';

/* Queries */
import { pdpRespCondensedRootQuery } from '../../queries/pdpRespCondensedRoot.js';

/* Reducers */
import { defaultReducers } from '../../reducers/reducerUtils.js';
import { pdpRespMakeOfferModalReducer as makeOfferModal } from '../../reducers/pdpRespMakeOfferModalReducer.ts';

/* Components */
import { PdpRespCondensedLayout } from '../../pdp/PdpRespCondensedLayout.jsx';

/* Helpers */
import { createEntry } from '../createEntry.jsx';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { datadog, initSharedDatadogRum, pdpTypes } from 'dibs-datadog/exports/datadog.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import { setDatadogABTestValues } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { storePdpVisit } from '../../pdp/PdpSharedNotifications/pdpSharedNotificationHelpers.js';

/**
 * DBL has a different environment that's created in initializeDBL.
 */
const options = {
    middleware: [thunk],
    reducers: {
        makeOfferModal,
        ...defaultReducers,
    },
};

const itemId = getItemIdFromUri(window.location.pathname);
if (itemId) {
    storePdpVisit({ itemId });
}

datadog.load().then(dd => {
    initSharedDatadogRum(dd, {
        device: 'resp',
        page: PAGE_TYPE.PDP,
        pageSubType: pdpTypes.condensed,
    });
    setDatadogABTestValues();
});

initializeDBL(options).then(async ({ store }) => {
    createEntry({
        Container: PdpRespCondensedLayout,
        store,
        query: pdpRespCondensedRootQuery,
    });

    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    if (itemId) {
        await initializePrerenderedCheckout({
            isMobile: false,
            itemId,
            locale,
            messages,
        });
    }
});
